// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const BreatheFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M41.882 82.48C27.448 79.937 16.063 68.552 13.52 54.118a6.239 6.239 0 0 1 0-12.236c2.543-14.434 13.928-25.819 28.362-28.362a6.239 6.239 0 0 1 12.236 0c14.434 2.543 25.819 13.928 28.362 28.362a6.239 6.239 0 0 1 0 12.236C79.937 68.552 68.552 79.937 54.118 82.48a6.239 6.239 0 0 1-12.236 0Zm.312-3.5a6.239 6.239 0 0 1 11.612 0c12.749-2.375 22.8-12.425 25.174-25.174a6.239 6.239 0 0 1 0-11.612c-2.375-12.749-12.425-22.8-25.174-25.174a6.239 6.239 0 0 1-11.612 0c-12.749 2.375-22.8 12.425-25.174 25.174a6.239 6.239 0 0 1 0 11.612c2.375 12.749 12.425 22.8 25.174 25.174ZM48.5 66.5c-9.941 0-18-8.059-18-18s8.059-18 18-18 18 8.059 18 18-8.059 18-18 18Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default BreatheFilled;
